export default __webpack_public_path__ + "static/media/urgent.59295479.svg";